class SetUpSlider extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }

    this.slider = this.querySelector(this.selectors.swiper);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.initSlider();
  }

initSlider() {
    const swiperParams = {
      slidesPerView: 2.138,
      spaceBetween: 10,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 15,
      breakpoints: {
        640: {
          slidesPerView: "auto",
          spaceBetween: 15,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 15,
        }
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      },
      on: {
        init() {
        }
      },
    };

    Object.assign(this.slider, swiperParams);

    this.slider.initialize();

  }
}

customElements.define('component-setup-slider', SetUpSlider);